const emotion = require('react-emotion');

module.exports = emotion;



//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-styles/emotion.js
// module id = 2
// module chunks = 0